import { useEffect, useState } from "react";
import axios from "axios";
import Footer from "../../../../../components/Footer/Footer";
import InnerNav from "../../../../../components/InnerNav/InnerNav";
import "./PlanetPos.scss";
import { useFormData } from '../../ContextData/ContextData';
import NavamsaChart from "./charts/navamsha/navamsha";
import LagnaChart from "./charts/lagna/lagna";

const PlanetPos = () => {
    const {userData} = useFormData();

  const [planetaryPositions, setPlanetaryPositions] = useState([]);
  const [dasha, setDasha] = useState([]);
  const [balanceDasha, setBalanceDasha] = useState("");
  const [karak, setKarak] = useState([]);
  const [avastha, setAvastha] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // API 1: Planatory Details
        const { data: details } = await axios.get(
          "https://core-c343.onrender.com/api/planatory-details",
          {
            params: { 
              year: userData.year,
              month: userData.month,
              day: userData.day,
              hour: userData.hour,
              minute: userData.minute 
            },
          }
        );

        setBalanceDasha(details.balanceOfDasha);

        const formattedDasha = details.sequence.map((seq) => {
          const name = seq.substring(0, 2); // e.g. Ra
          const date = seq.substring(2); // e.g. 02/08/2009
          return { name, date };
        });
        setDasha(formattedDasha);

        const karakArray = Object.keys(details.karak.Sthir).map((key) => ({
          karak: key,
          sthir: details.karak.Sthir[key],
          chara: details.karak.Chara[key],
        }));
        setKarak(karakArray);

        // API 2: Avasthas
        const { data: avasthaData } = await axios.get(
          "https://core-c343.onrender.com/api/planatory-avasta",
          {
            params: { 
              year: userData.year,
              month: userData.month,
              day: userData.day,
              hour: userData.hour,
              minute: userData.minute 
            },
          }
        );
        setAvastha(avasthaData.avasthas);

        // API 3: Daily Planetary Positions
        const { data: posData } = await axios.get(
          "https://core-c343.onrender.com/api/daily-planet-position",
          {
            params: {
              year: userData.year,
              month: userData.month,
              day: userData.day,
              hour: userData.hour,
              minute: userData.minute ,
              location: userData.city,
            },
          }
        );
        setPlanetaryPositions(posData.result);
      } catch (err) {
        console.error("Error fetching planetary data:", err);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="PlanetPos-details">
      <InnerNav />
        {/* Charts Section */}
      <div className="charts-containerrr">
        <div className="chart-card">
          <LagnaChart />
        </div>

        <div className="chart-card">
          <NavamsaChart />
        </div>
      </div>
      <div className="table-section">
        {/* Planetary Positions */}
        <div className="main-table">
          <table>
            <thead>
              <tr>
                <th>Planets</th>
                <th>Longitude</th>
                <th>Rashi</th>
                <th>Nakshatra</th>
                <th>Pada</th>
              </tr>
            </thead>
            <tbody>
              {planetaryPositions.map((p, i) => (
                <tr key={i}>
                  <td>{p.planet}</td>
                  <td>{p.fullDegree}</td>
                  <td>{p.fullDegree.split("in sign")[1]?.trim()}</td>
                  <td>{p.nakshatra}</td>
                  <td>{p.padam}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="note">
            Note : [C / *] - Combust [D] - Direct [R / *] - Retrograde [E] -
            Eclipse
          </p>
        </div>

        {/* Dasha */}
        <div className="dasha-card">
          <div className="card-header">Vimshottari Dasha</div>
          <p className="dasha-balance">Balance Of Dasha : {balanceDasha}</p>
          <table>
            <tbody>
              {dasha.map((d, i) => (
                <tr key={i}>
                  <td>{d.name}</td>
                  <td>{d.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Karak + Avastha */}
      <div className="sub-tables">
        {/* Karak */}
        <div className="sub-table">
          <div className="card-header">Karak</div>
          <table>
            <thead>
              <tr>
                <th>Karak</th>
                <th>Sthir</th>
                <th>Chara</th>
              </tr>
            </thead>
            <tbody>
              {karak.map((k, i) => (
                <tr key={i}>
                  <td>{k.karak}</td>
                  <td>{k.sthir}</td>
                  <td>{k.chara}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Avastha */}
        <div className="sub-table">
          <div className="card-header">Avastha</div>
          <table>
            <thead>
              <tr>
                <th>Planets</th>
                <th>Jagrat</th>
                <th>Baladi</th>
                <th>Deeptadi</th>
              </tr>
            </thead>
            <tbody>
              {avastha.map((a, i) => (
                <tr key={i}>
                  <td>{a.planet}</td>
                  <td>{a.Jagrat}</td>
                  <td>{a.Baladi}</td>
                  <td>{a.Deeptadi}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PlanetPos;
